"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLayout = buildLayout;
exports.getAudioPresenterLayers = getAudioPresenterLayers;
exports.getPresenterBanner = getPresenterBanner;
Object.defineProperty(exports, "isBackground", {
  enumerable: true,
  get: function get() {
    return _scene.isBackground;
  }
});
Object.defineProperty(exports, "isOverlay", {
  enumerable: true,
  get: function get() {
    return _scene.isOverlay;
  }
});
exports.sceneBuilder = sceneBuilder;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _underscore = require("underscore");
var _SourceItems = require("../../constants/SourceItems");
var _SceneLayouts = require("../../constants/SceneLayouts");
var _Banners = require("../../constants/Banners");
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper/broadcastSourceHelper");
var _scene = require("../../utils/scene/scene");
var _gridBuilder = _interopRequireDefault(require("../gridBuilder/gridBuilder"));
var _singleBuilder = _interopRequireDefault(require("../singleBuilder/singleBuilder"));
var _featuredBuilder = _interopRequireDefault(require("../featuredBuilder/featuredBuilder"));
var _sideBySideBuilder = _interopRequireDefault(require("../sideBySideBuilder/sideBySideBuilder"));
var _featuredPresenterBuilder = _interopRequireDefault(require("../featuredPresenterBuilder/featuredPresenterBuilder"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @deprecated Use version in `@studio/program`
 * @param {Array} sources
 */
function getAudioPresenterLayers(sources) {
  var filterAudioPresenter = sources.filter(function (source) {
    return source && source.type === _SourceItems.AUDIO_PRESENTER;
  });
  return filterAudioPresenter.map(function (source) {
    return {
      source: source,
      layer: {},
      _id: source._id
    };
  });
}

/**
 * @deprecated Use version in `@studio/program`
 * @description Get presenter banner template that is live
 * @param  layerSources
 * @returns {{} | undefined}
 */
function getPresenterBanner(layerSources) {
  // Return `undefined` just like `array.find` would
  if (!layerSources.length) return undefined;
  return layerSources.find(function (layer) {
    var _layer$source;
    return (
      // Check if layer is object and not of type `SCENE_LAYER` and is not hidden
      (0, _typeof2["default"])(layer) === 'object' && !(layer !== null && layer !== void 0 && layer.source.hidden) && (layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 || (_layer$source = _layer$source.value) === null || _layer$source === void 0 ? void 0 : _layer$source.templateType) === _Banners.PRESENTER_BANNER
    );
  });
}

/**
 * @description Apply layers to scene layers,
 * if presenter banner template is live,
 * generate individual presenter banners
 * and render them below each live tile
 * @param {{
 * style : {}
 * layers : []
 * }} mainScene
 * @param  layerSources
 * @param {boolean} isPreview If `true` we can pass presenter banner layer source to scene even if we don't have a live camera source
 */
function applyLayerSources() {
  var mainScene = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var layerSources = arguments.length > 1 ? arguments[1] : undefined;
  var isPreview = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (layerSources.length) {
    var layers = [];
    layerSources.forEach(function (layerSource) {
      if (layerSource === 'SCENE_LAYER') {
        layers = mainScene.layers ? layers.concat(mainScene.layers) : layers;
        /**
         * For sources like banners, overlays and backgrounds,
         * we still need to check source.hidden property
         */
      } else if ([_SourceItems.MEDIA, _SourceItems.PDF_FILE, _SourceItems.AUDIO_FILE, _SourceItems.VIDEO_FILE, _SourceItems.IMAGE_FILE, _SourceItems.CAMERA_PRESENTER, _SourceItems.SCREEN_PRESENTER].includes(layerSource.source.type) || !layerSource.source.hidden) {
        var source = layerSource.source,
          layer = layerSource.layer,
          id = layerSource._id;
        var value = source.value,
          type = source.type;
        var style = layer.style;
        /**
         * Check if it appears to be a background,
         * if so, merge layer styles with container style,
         * and set the background image to the source value.
         */
        if ((0, _scene.isBackground)(style)) {
          var imageUrl = (0, _typeof2["default"])(value) === 'object' ? value.url : value;
          mainScene.style = _objectSpread(_objectSpread(_objectSpread({}, mainScene === null || mainScene === void 0 ? void 0 : mainScene.style), style), {}, {
            zIndex: 0,
            backgroundId: id,
            backgroundImage: "url(".concat(imageUrl, ")")
          });
        } else {
          /**
           * Only handle non-presenter banners since presenter banners
           * will be rendered below individual live video tiles in scene.
           */
          var sourceValue = source.value;
          var isPresenter = (0, _scene.isPresenterBannerLayerSource)(sourceValue);
          var shouldGenerateLayerSource = isPreview || !isPresenter;
          if (shouldGenerateLayerSource) {
            /**
             * This is a normal banner or overlay and should appear on top of everything in scene.
             * Set it to a higher value than possible camera sources that can be in scene.
             */
            if (type === _SourceItems.BANNER || (0, _scene.isOverlay)(style)) {
              var updatedLayer = _objectSpread(_objectSpread({}, layerSource), {}, {
                layer: _objectSpread(_objectSpread({}, layer), {}, {
                  style: _objectSpread(_objectSpread({}, style), {}, {
                    zIndex: 20
                  })
                })
              });
              layers.push(updatedLayer);
            } else {
              layers.push(layerSource);
            }
          }
        }
      }
    });
    var sceneLayers = (mainScene === null || mainScene === void 0 ? void 0 : mainScene.layers) || [];
    var presenterBanner = getPresenterBanner(layerSources);
    if (presenterBanner && (0, _scene.isIterable)(sceneLayers)) {
      (0, _toConsumableArray2["default"])(sceneLayers).map(function (sourceLayer) {
        var source = sourceLayer.source;
        var type = source.type;
        if (type === _SourceItems.CAMERA_PRESENTER) {
          var banner = (0, _scene.buildPresenterBannerLayerSource)(presenterBanner, sourceLayer, mainScene._id, sceneLayers);
          layers.push(banner);
          return banner;
        }
        return layers;
      });
    }
    mainScene.layers = layers;
  }
  return mainScene;
}

/**
 * @deprecated Use version in `@studio/program`
 * @param {{}} layout
 * @param {Array} sources
 * @param  layerSources
 * @param {{}} sourceStyle
 * @param {{}} otherConfig
 * @param {{
 * isPreview : boolean
 * }} otherConfig We can pass custom config inside this object
 * @example We can pass `isPreview` flag when creating a scene preview
 */
function sceneBuilder(layout, sources) {
  var layerSources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var sourceStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var otherConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var nonAudioPresenterSources = (0, _scene.getNonAudioPresenterSources)(sources);
  var sortedSources = (0, _scene.moveFeaturedPresenterToFront)(nonAudioPresenterSources);
  var audioSourceIndex = (0, _scene.getAudioSourceIndex)(sortedSources);
  var audioSourceExists = audioSourceIndex > -1;
  var audioSource = null;
  if (audioSourceExists) {
    audioSource = sortedSources.splice(audioSourceIndex, 1)[0];
  }
  var isPreview = otherConfig.isPreview;
  var builtScene = buildLayout(layout, sortedSources, layerSources, sourceStyle, isPreview);
  if (audioSourceExists && audioSource) {
    var audioLayer = (0, _scene.addAudioSourceToScene)(audioSource);
    builtScene.layers.unshift(audioLayer);
  }
  var audioPresenterLayers = getAudioPresenterLayers(sources);
  if (!(0, _underscore.isEmpty)(audioPresenterLayers)) {
    builtScene.layers = builtScene.layers.concat(audioPresenterLayers);
  }
  return builtScene;
}

/**
 * @deprecated Use version in `@studio/program`
 * @param {{}} layout
 * @param {Array} sources
 * @param  layerSources
 * @param {{}} sourceStyle
 * @param {Boolean} isPreview
 */
function buildLayout(layout, sources) {
  var layerSources = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var sourceStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var isPreview = arguments.length > 4 ? arguments[4] : undefined;
  var mainScene;
  var mergedSourceStyle = _objectSpread(_objectSpread({}, _scene.COMMON_SOURCE_STYLES), sourceStyle);
  if ((0, _broadcastSourceHelper.isLayout)(layout, _SceneLayouts.SINGLE)) {
    /**
     * The reason why this code is necessary is because if overlays are the only sources left when rebuilding a scene it will glitch and make those overlays full screen
     * There is a weird thing going on with overlays when it's passed around layerSources.
     * The overlay positions on the program are unique to overlays and they are stored in the style part of the overlays properties
     * However when it is sent to layerSources it is somehow stored in the title property of overlays
     * We need to investigate why the property gets changed and fix it. When fixed we can then do the code below with isOverlay() function.
     */
    var overlayTitles = new Set(['Upper left', 'Upper right', 'Lower left', 'Lower right', 'Full Screen']);
    var containsOnlyOverlays = layerSources.length >= 2 && layerSources.slice(1).every(function (layerSource) {
      var _layerSource$layer;
      return overlayTitles.has((_layerSource$layer = layerSource.layer) === null || _layerSource$layer === void 0 ? void 0 : _layerSource$layer.title);
    });
    if (!containsOnlyOverlays) {
      mainScene = (0, _singleBuilder["default"])(sources[0], mergedSourceStyle);
    }
  }
  if ((0, _broadcastSourceHelper.isLayout)(layout, _SceneLayouts.SIDE_BY_SIDE)) {
    mainScene = (0, _sideBySideBuilder["default"])(sources, mergedSourceStyle);
  }
  if ((0, _broadcastSourceHelper.isLayout)(layout, _SceneLayouts.GRID)) {
    mainScene = (0, _gridBuilder["default"])(sources, mergedSourceStyle);
  }
  if ((0, _broadcastSourceHelper.isLayout)(layout, _SceneLayouts.FEATURED_PRESENTER)) {
    mainScene = (0, _featuredPresenterBuilder["default"])(sources, mergedSourceStyle);
  }
  if ((0, _broadcastSourceHelper.isLayout)(layout, _SceneLayouts.FEATURED_SCREEN)) {
    mainScene = (0, _featuredBuilder["default"])(sources, _SourceItems.SCREEN_PRESENTER, mergedSourceStyle);
  }
  if ((0, _broadcastSourceHelper.isLayout)(layout, _SceneLayouts.FEATURED_MEDIA)) {
    mainScene = (0, _featuredBuilder["default"])(sources, [_SourceItems.IMAGE_FILE, _SourceItems.PDF_FILE, _SourceItems.VIDEO_FILE, _SourceItems.MEDIA], mergedSourceStyle);
  }

  // TODO: Rename to mainScene.layoutId once we allow this to be sent to API
  if (mainScene) {
    mainScene._id = layout.id;
  }
  return applyLayerSources(mainScene, layerSources, isPreview);
}